module.exports = __webpack_public_path__ + "static/media/sensorLogo.33107469.png";